import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs';

/**
 * Intercepts HTTP responses from the Razor API and unwraps the ApiResponse<T> envelope.
 *
 * The Rust backend wraps every API response in:
 *   { success: boolean, data: T | null, error: ErrorDetail | null, metadata: ResponseMetadata | null }
 *
 * This interceptor extracts the `data` field from successful responses so that
 * downstream subscribers receive the inner payload directly, matching the
 * types declared in the OpenAPI spec and generated TypeScript clients.
 *
 * Only applies to requests targeting `/api/` paths to avoid interfering with
 * non-API HTTP calls (asset loading, third-party services, etc.).
 *
 * For error responses (success: false), the original envelope is preserved
 * so error interceptors can inspect the error details.
 */
export const apiResponseInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    map(event => {
      if (
        req.url.includes('/api/') &&
        event instanceof HttpResponse &&
        event.body != null &&
        typeof event.body === 'object' &&
        'success' in event.body &&
        'data' in event.body
      ) {
        const envelope = event.body as { success: boolean; data: unknown };
        if (envelope.success) {
          return event.clone({ body: envelope.data });
        }
      }
      return event;
    })
  );
};
